const config = {
  id: 27,
  name: '品牌日 三',
  type: 1,
  module_code: 'active_day3', // bind的配置文件
  icon: 'icon-tms-red-packet',
  font_icon: '&#xe60a;',
  style_type: 1,
  link_type: 0,
  property_data: {
    type: 1,
    btn_bg_color: '#a40000',
    price_color: '#a40000',
  }
};

export default config;


